import { useQuery } from '@apollo/react-hooks';
import {
  GetAllSteps,
  GetAllStepsVariables,
} from '../../graphql/step/types/GetAllSteps';
import { GET_ALL_STEPS } from '../../graphql/step/query';

export const useStep = () => {
  return useQuery<GetAllSteps, GetAllStepsVariables>(GET_ALL_STEPS, {
    variables: { input: {} },
  });
};
